
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c924a5c8&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InfoModal.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./InfoModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c924a5c8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InfoModal.vue"),
  /* scopeId */
  "data-v-c924a5c8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UIComponents/InfoModal.vue
// module id = 229
// module chunks = 3